export const VALIDATED_TOKEN ='VALIDATED_TOKEN';
export const VALIDATION_ERROR ='VALIDATION_ERROR';
export const GET_EVENTS ='GET_EVENTS';
export const GET_ME ='GET_ME';
export const ERROR ='ERROR';
export const GET_MY_EVENTS ='GET_MY_EVENTS';
export const EVENTS_LOADING='EVENTS_LOADING'
export const DELETED_EVENT ='DELETED_EVENT';
export const ERROR_SEND ='ERROR_SEND';
export const SEND_MAIL ='SEND_MAIL';
export const OPEN_ALERT='OPEN_ALERT';
export const CLOSE_ALERT='CLOSE_ALERT';

 